var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { RfpMessageListItem } from '@/components/modules/pages/rfp/client/List/RfpMessageListItem';
import { ColorPaperButton } from '@/components/ui/Button/ColorPaperButton';
import { reDraw } from '@/helpers/common';
import { usePrevious } from '@/hooks/lifecycle/usePrevious';
import { useBoolState } from '@/hooks/state/useBoolState';
import { sleep } from '@/utils/async/sleep';
// アコーディオン開閉時間
export const transitionTime = 250;
/**
 * レスポンシブを考慮した、開閉制御が可能なメッセージ表示コンポーネント
 * TODO: 既存のRfpMessageListRowも、PC表示時に開閉処理がチラつくので要修正
 * @description 既存のRfpMessageListRowが条件相談専用のコンポーネントになっていたため、汎用的に使えるようにしました TODO: 既存と差し替え
 * @param props
 * @constructor
 */
export const RfpMessageListRowCollapsible = (props) => {
    const { children, companyName, disabled, hasUnAnswer, id, isSelected, onClick, unReadCount, } = props;
    const divRef = useRef();
    const { boolState, changeFalse, changeTrue } = useBoolState({
        initialState: isSelected,
    });
    const previewIsChecked = usePrevious(isSelected);
    // 表示状態の変遷の指定
    const viewMode = useMemo(() => {
        if (previewIsChecked === false && isSelected) {
            // false => trueになった場合
            return 'update_on';
        }
        if (previewIsChecked === true && !isSelected) {
            // true => falseになった場合
            return 'update_off';
        }
        if (previewIsChecked === undefined && isSelected) {
            // 初期表示の場合
            return 'default_on';
        }
        // 初期表示ではない場合
        return 'default_off';
    }, [previewIsChecked, isSelected]);
    // 要素の高さの指定
    const [height, changeHeight] = useState('0px');
    const heightRef = useRef();
    heightRef.current = height;
    const collapse = useCallback((startHeight, doingHeight, endHeight) => __awaiter(void 0, void 0, void 0, function* () {
        // 既に最終状態、もしくはマウントされたコンポーネント自体が存在しない場合は何もしない
        if (heightRef.current === endHeight || !divRef.current) {
            return;
        }
        // 初期設定
        changeHeight(startHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(0);
        // 初期設定から移動先の高さへ変更
        changeHeight(doingHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(transitionTime);
        // 最終設定の高さに
        changeHeight(endHeight);
        yield sleep(0);
        reDraw(divRef.current);
        yield sleep(0);
    }), [divRef, heightRef, changeHeight]);
    const collapseOn = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const currentHeight = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
        yield collapse(`0px`, `${currentHeight}px`, 'auto');
    }), [divRef, collapse]);
    const collapseOff = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const currentHeight = (_b = divRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height;
        yield collapse(`${currentHeight}px`, `0px`, `0px`);
    }), [divRef, collapse]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (viewMode === 'update_on') {
                // false => trueになった場合
                changeHeight('0px');
                changeTrue();
                yield sleep(0);
                yield collapseOn();
            }
            if (viewMode === 'update_off') {
                // true => falseになった場合
                yield collapseOff();
                changeFalse();
            }
        }))();
    }, [viewMode, divRef, changeTrue, changeFalse, collapseOn, collapseOff]);
    const setCss = css `
    height: ${height};
  `;
    const onClickListItem = useCallback((value) => __awaiter(void 0, void 0, void 0, function* () {
        onClick(value);
        yield collapseOn();
    }), [onClick, collapseOn]);
    return (_jsxs(_Fragment, { children: [_jsx(RfpMessageListItem, { className: 'block md:hidden lg:block xl:hidden', companyName: companyName, disabled: disabled, hasUnAnswer: hasUnAnswer, id: id, isSelected: isSelected, onClick: onClickListItem, unReadCount: unReadCount }), boolState && (_jsx("div", Object.assign({ className: clsx('transition-[height] md:transition-none duration-[250ms]', 'overflow-y-hidden h-0 md:!h-auto'), css: height ? setCss : undefined }, { children: _jsxs("div", Object.assign({ ref: (element) => {
                        if (element) {
                            divRef.current = element;
                        }
                    } }, { children: [children, _jsx(ColorPaperButton, Object.assign({ className: 'block md:hidden lg:block xl:hidden', onClick: collapseOff }, { children: "\u9589\u3058\u308B" }))] })) })))] }));
};
